import React from "react";
import { FloatingTechIconProps } from "./types";
import { ICON_COLORS, ICON_COMPONENTS } from "./constants";
import { IconWrapper, NeoBrutalistIcon } from "./styles";

export const FloatingTechIcon: React.FC<FloatingTechIconProps> = ({
  theme,
  size,
  top,
  left,
  animate,
  transition,
  icon,
}) => {
  const IconComponent = ICON_COMPONENTS[icon];
  const bgColor = ICON_COLORS[icon];

  return (
    <IconWrapper
      theme={theme}
      size={size}
      top={top}
      left={left}
      animate={animate}
      transition={transition}
    >
      <NeoBrutalistIcon theme={theme} bgColor={bgColor}>
        <IconComponent />
      </NeoBrutalistIcon>
    </IconWrapper>
  );
};
